import * as React from "react";

export const SIDEBAR_WIDTH = "16rem";
export const SIDEBAR_WIDTH_MOBILE = "18rem";
export const SIDEBAR_WIDTH_ICON = "3rem";

export type SidebarContextValue = {
  state: "expanded" | "collapsed";
  open: boolean;
  setOpen: (open: boolean) => void;
  openMobile: boolean;
  setOpenMobile: (open: boolean) => void;
  isMobile: boolean;
  toggleSidebar: () => void;
};

export const SidebarContext = React.createContext<SidebarContextValue | null>(
  null
);

export function useSidebar() {
  const context = React.useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider.");
  }

  return context;
}

/**
 * The sidebar state when a sidebar is mounted, null otherwise. A fixed element
 * that has to clear the rail reads this instead of assuming a width.
 */
export function useSidebarOptional() {
  return React.useContext(SidebarContext);
}

/**
 * The width the rail actually occupies, as a CSS length: the icon rail while
 * collapsed, the full width while open, nothing on a phone where the sidebar
 * is a sheet.
 */
export function sidebarRailWidth(sidebar: SidebarContextValue | null): string {
  if (!sidebar || sidebar.isMobile) return "0px";
  return sidebar.state === "collapsed"
    ? "var(--sidebar-width-icon)"
    : "var(--sidebar-width)";
}
